import { Row, Col } from "../../App.styles";

const QRCode = () => {
  return (
    <>
      <Row>
        <Col>
          <p>Complete by: QR Code</p>
        </Col>
      </Row>
    </>
  );
};

export default QRCode;
